import * as Types from '../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetEventTypeQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;

export type GetEventTypeQuery = {
  __typename?: 'Query';
  eventByName?: { __typename?: 'Event'; id: string; info: { __typename?: 'EventInfo'; id: string; eventType: Types.EventType } } | null;
};

export const GetEventTypeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventTypeQuery__
 *
 * To run a query within a React component, call `useGetEventTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTypeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetEventTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventTypeQuery, GetEventTypeQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventTypeQuery, GetEventTypeQueryVariables>(GetEventTypeDocument, baseOptions);
}
export function useGetEventTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventTypeQuery, GetEventTypeQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventTypeQuery, GetEventTypeQueryVariables>(GetEventTypeDocument, baseOptions);
}
export type GetEventTypeQueryHookResult = ReturnType<typeof useGetEventTypeQuery>;
export type GetEventTypeLazyQueryHookResult = ReturnType<typeof useGetEventTypeLazyQuery>;
export type GetEventTypeQueryResult = Apollo.QueryResult<GetEventTypeQuery, GetEventTypeQueryVariables>;
